import TableBonusRewardTypeCell from '@/components/core/Table/CustomCells/BonusRewardTypeCell';
import MultiExchangeCell from '@/components/core/Table/CustomCells/MultiExchangeCell';
import { UserRewardTracker } from '@/models/user-reward/tracker';
import { TableGridColumn } from '@starsoft/common/src/components/TableGrid/props';

export const bonusRewardTypeColumns: TableGridColumn<UserRewardTracker>[] = [
  {
    field: 'reward.name',
    headerName: 'bonus_type',
    renderCell: bonusRewardType => (
      //@ts-ignore
      <TableBonusRewardTypeCell rewardType={bonusRewardType.reward} />
    ),
  },
  {
    field: 'amount',
    headerName: '',
    alignEnd: true,
    renderCell: row => <MultiExchangeCell row={row.amount} />,
  },
];
